import useSitecoreContext from './useSitecoreContext';

const isComponentsValid = (component: any) => !!component.uid;

const isComponentInTheList = (component: any, exceptComponentNames: Array<string>) =>
  exceptComponentNames.indexOf(component.componentName) >= 0;

const useBreadcrumbBarAsFirstComponent = (exceptComponentNames: Array<string>) => {
  const {sitecoreContext} = useSitecoreContext();
  const componentList = (sitecoreContext?.route?.placeholders['jss-main'] || []) as any;

  return (
    componentList
      .filter((component) => isComponentsValid(component))
      .filter((component) => !isComponentInTheList(component, exceptComponentNames))
      .findIndex((rendering) => rendering.componentName === 'BreadcrumbBar') === 0
  );
};

export default useBreadcrumbBarAsFirstComponent;
